document.addEventListener('DOMContentLoaded', async () => {
	// GET USERLOCALE
	var userLocale = document.documentElement.lang.slice(-2);
	if (userLocale.includes('uk')) {
	  userLocale.replace("uk", 'gb')
	}
	userLocale = userLocale.toUpperCase();
	
	const locationCache = {};

	const getCountryName = (countryCode) => {
		const countryNames = {
			GB: 'United Kingdom',
			FR: 'France',
			DE: 'Germany',
			IE: 'Ireland',
			IT: 'Italy',
			ES: 'Spain',
			AT: 'Austria',
			BE: 'Belgium',
			NL: 'Netherlands',
			JP: 'Japan',
		};
		return countryNames[countryCode] || '';
	};

	const deg2rad = (deg) => deg * (Math.PI / 180);

	const getDistanceHaversine = (lat1, lon1, lat2, lon2) => {
		const R = 6371;
		const dLat = deg2rad(lat2 - lat1);
		const dLon = deg2rad(lon2 - lon1);
		const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
			Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) *
			Math.sin(dLon / 2) * Math.sin(dLon / 2);
		const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
		const distanceInKm = R * c;

		return userLocale === 'GB' ? distanceInKm * 0.621371 : distanceInKm;
	};

	const fetchPost = async (url, body) => {
		const response = await fetch(url, {
			method: 'POST',
			headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
			body: new URLSearchParams(body).toString(),
		});
		if (!response.ok) throw new Error('Network response was not ok');
		return response.json();
	};

	// const updateElementWithAddress = (element, address) => {
	// 	if (element && address.length > 0) {
	// 		element.href = `/roles/?search_location=${encodeURIComponent(address)}&distance=50`;
	// 		element.style.display = 'flex';
	// 	} else {
	// 		console.error('Address not found');
	// 	}
	// };

	// const getLocationDetails = async ({ latlng, elemToDisplay }) => {
	// 	if (locationCache[latlng]) {
	// 		updateElementWithAddress(elemToDisplay, locationCache[latlng]);
	// 		return;
	// 	}
	//
	// 	try {
	// 		const data = await fetchPost(distanceMatrixData.ajax_url, {
	// 			action: 'get_location_details',
	// 			latlng,
	// 		});
	//
	// 		if (data.status === 'OK') {
	// 			const { formattedAddress } = data.data;
	// 			locationCache[latlng] = formattedAddress;
	// 			updateElementWithAddress(elemToDisplay, formattedAddress);
	// 		} else {
	// 			console.error(`Error: ${data.message}`);
	// 		}
	// 	} catch (error) {
	// 		console.error('Error:', error);
	// 		console.error('Failed to retrieve location details.');
	// 	}
	// };

	const getLocationCoordinates = async (address) => {
		if (locationCache['positions'] !== undefined && locationCache['positions'] !== null) {
			return locationCache['positions'];
		}

		try {
			const data = await fetchPost(distanceMatrixData.ajax_url, {
				action: 'get_location_coordinates',
				address,
			});

			if (data.status === 'OK') {
				const {
					latitude,
					longitude,
					postal_town
				} = data.data;
				locationCache['positions'] = {
					latitude,
					longitude,
					postal_town
				};
				return {
					latitude,
					longitude,
					postal_town
				};
			}

			// Return error information when validation fails
			return {
				latitude: null,
				longitude: null,
				error: data.message || 'Postal/zip code validation failed'
			};
		} catch (error) {
			console.error('Error:', error);
			console.error('Failed to retrieve location coordinates.');
			return {
				latitude: null,
				longitude: null,
				error: 'Network error occurred while validating postal/zip code'
			};
		}
	};

	const ROLE_SEARCH_URL = '/roles/?search_location=';
	const ROLE_SEARCH_URL_COORDINATE = '/roles/?search_coordinate=';
	const DISTANCE_PARAM = '&distance=50';
	const DISPLAY_FLEX = 'flex';

	const getCurrentLocationCoordinates = async (currentLocation, isPostcode) => {
		return isPostcode ? await getLocationCoordinates(currentLocation) : currentLocation;
	};

	const calculateAndDisplayDistance = (props) => {
		const {
			distance,
			elemToDisplay,
			postcodeError,
			searchLocation
		} = props;

		if (distance >= 50) {
			if (postcodeError) postcodeError.style.display = 'none';
			elemToDisplay.href = `${postcodeError ? ROLE_SEARCH_URL : ROLE_SEARCH_URL_COORDINATE}${encodeURIComponent(searchLocation)}${DISTANCE_PARAM}`;
			elemToDisplay.style.display = DISPLAY_FLEX;
		}
	};

	const getDistance = async (props) => {
		const {
			currentLocation,
			roleLocation,
			elemToDisplay,
			isPostcode = false,
			postcodeError
		} = props;

		try {
			const locationData = await getCurrentLocationCoordinates(currentLocation, isPostcode);
			if (!locationData) return;  // Early return if locationData is not retrieved

			// Check if postcode validation failed (coordinates are null)
			if (isPostcode && (!locationData.latitude || !locationData.longitude)) {
				if (postcodeError) {
					postcodeError.textContent = locationData.error || 'Please enter a valid postal/zip code';
					postcodeError.style.display = 'block';
				}
				if (elemToDisplay) {
					elemToDisplay.style.display = 'none';
				}
				return;
			}

			const distance = getDistanceHaversine(
				locationData.latitude,
				locationData.longitude,
				roleLocation.latitude,
				roleLocation.longitude
			);

			const searchLocation = isPostcode ? locationData.postal_town : `${locationData.latitude}, ${locationData.longitude}`;
			const calculateAndDisplayDistanceProps = {
				distance,
				elemToDisplay,
				postcodeError,
				searchLocation
			};

			console.log('PC', 'Distance: ' + distance);

			calculateAndDisplayDistance(calculateAndDisplayDistanceProps);
		} catch (error) {
			console.error('Error:', error);
			console.error('Failed to calculate distance.');
		}
	};

	const debounce = (func, delay) => {
		let timer;
		return function (...args) {
			clearTimeout(timer);
			timer = setTimeout(() => func.apply(this, args), delay);
		};
	};

	const getCurrentLocation = () => new Promise((resolve, reject) => {
		if (navigator.geolocation) {
			navigator.geolocation.getCurrentPosition(
				(position) => resolve(position.coords),
				(error) => reject(error),
			);
		} else {
			reject(new Error('Geolocation is not supported by this browser.'));
		}
	});

	const validatePostcode = (postcode, userLocale) => {
		const postcodePatterns = [
			{ locale: "DE", pattern: /^\d{5}$/ },
			{ locale: "UK", pattern: /^([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z])))) \d[A-Za-z]{2})$/ },
			{ locale: "FR", pattern: /^\d{5}$/ },
			{ locale: "IE", pattern: /^[A-Za-z0-9]{3} ?[A-Za-z0-9]{4}$/ },
			{ locale: "IT", pattern: /^\d{5}$/ },
			{ locale: "ES", pattern: /^\d{5}$/ },
			{ locale: "AT", pattern: /^\d{4}$/ },
			{ locale: "BE", pattern: /^\d{4}$/ },
			{ locale: "NL", pattern: /^\d{4}\s?[A-Z]{2}$/ },
			{ locale: "JP", pattern: /^\d{3}-?\d{4}$/ }
		];
		const postcodePattern = postcodePatterns.find(pattern => pattern.locale === userLocale);
		if(postcodePattern) {
			const postcodeRegex = new RegExp(postcodePattern.pattern);
			return postcodeRegex.test(postcode);
		}
	}

	const getLocationDetailsFromPostcode = async (postcode, country) => {
		const apiKey = 'AIzaSyCoIJwYY2BGKklhrcdAjxmAC5-P56tLRbg';
		const searchAddress = `${postcode}, ${country}`;
		const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(searchAddress)}&key=${apiKey}`;
	
		try {
			const response = await fetch(url);
			const data = await response.json();
	
			if (data.status === 'OK' && data.results.length > 0) {
				const result = data.results[0];
				const { lat, lng } = result.geometry.location;
	
				let city = '';
				let region = '';
				let country = '';
				let country_code = '';
	
				for (const component of result.address_components) {
					if (component.types.includes('locality')) {
						city = component.long_name;
					}
					if (component.types.includes('administrative_area_level_1')) {
						region = component.long_name;
					}
					if (component.types.includes('administrative_area_level_2') && !region) {
						region = component.long_name;
					}
					if (component.types.includes('country')) {
						country = component.long_name;
						country_code = component.short_name;
					}
				}
	
				return {
					city,
					region,
					country,
					country_code,
					latitude: lat,
					longitude: lng
				};
			} else {
				throw new Error('No results found for the given postcode.');
			}
		} catch (error) {
			console.error('Error fetching location details:', error);
			return null;
		}
	}

	const handlePostcodeChange = async (postcode, roleLocation) => {
			const postcodeDistanceToWork = document.getElementById('postcode-distance-to-work-check');
			const postcodeDistanceErrorElem = document.querySelectorAll('.postcode-distance-error');
			const postcodeError = document.getElementById('postcode-error');
			const pc = postcode.value.trim();
			const pcValid = validatePostcode(pc, userLocale);
			const country = getCountryName(userLocale);
			let currentLocation = '';
			let proceedToDistanceCalculation = false;

			postcodeDistanceErrorElem.forEach((elem) => {
				elem.style.display = 'none';
			});

			if (postcodeError) {
				postcodeError.style.display = 'none';
			}

			if(!pcValid) {
				console.log('PC', 'Regex Failed for ' + pc + ' with locale ' + userLocale);
				if (postcodeError) {
					postcodeError.style.display = 'block';
				}
				currentLocation = '';
			} else {
				console.log('PC', 'Regex Passed for ' + pc + ' with locale ' + userLocale);
				try {
					const location = await getLocationDetailsFromPostcode(pc, country);
					if (location) {
						console.log('PC', 'Location Found for ' + pc + ' with locale ' + userLocale);

						document.getElementById('user_city').value = location.city || '';
						document.getElementById('user_region').value = location.region || '';
						document.getElementById('user_country').value = location.country || '';
						document.getElementById('user_country_code').value = location.country_code || '';
						document.getElementById('user_latitude').value = location.latitude || '';
						document.getElementById('user_longitude').value = location.longitude || '';
						document.querySelector('#postcode-error').style.display = 'none';

						if (postcodeError) {
							postcodeError.style.display = 'none';
						}
						currentLocation = `${pc}, ${location.country}`;
						proceedToDistanceCalculation = true;
					} else {
						console.log('PC', 'Location Not Found for ' + pc + ' with locale ' + userLocale);
						if (postcodeError) {
							postcodeError.style.display = 'block';
						}
						currentLocation = '';
					}
				} catch (error) {
					console.log('PC', 'Error in getLocationDetailsFromPostcode for ' + pc + ' with locale ' + userLocale);
					currentLocation = '';
				}
			}

			console.log('PC', 'Proceeding to Distance Calculation: ' + proceedToDistanceCalculation);
			if(proceedToDistanceCalculation) {
				postcodeDistanceErrorElem.forEach((elem) => {
					elem.style.display = 'none';
				});

				if (postcodeError) {
					postcodeError.style.display = 'none';
				}

				if (locationCache['positions']) {
					delete locationCache['positions'];
				}

				if (currentLocation.length > 0) {
					console.log('PC', 'Current Location: ' + currentLocation);
					await getDistance({
						currentLocation,
						roleLocation,
						elemToDisplay: postcodeDistanceToWork,
						isPostcode: true,
						postcodeError: postcodeError,
					});
				}
			}
	}

	const initEventListeners = async () => {
		const roleLocationElem = document.getElementById('role-location');
		const postcode = document.getElementById('postcode');
		const submitButton = document.getElementById('application-submit');

		let roleLocation;
		if(roleLocationElem) {
			roleLocation = {
				latitude: Number(roleLocationElem.getAttribute('data-location-lat')),
				longitude: Number(roleLocationElem.getAttribute('data-location-lon')),
			};
		} else {
			return;
		}

		if (postcode) {
			
			// Validate postcode on focusout
			postcode.addEventListener('focusout', debounce(async () => {
				await handlePostcodeChange(postcode, roleLocation);
			}, 100));
			
			// Validate postcode on submit
			submitButton.addEventListener('click', async () => {
				await handlePostcodeChange(postcode, roleLocation);
			});
		}
	};
	await initEventListeners();
});


